<template lang="html">
  <BaseLoading  opaque :spinning="collegeTeamHighlightsLoading">
    <div class="events-list-wrap create-profile-wrapper">
      <div class="top-head">
        <div class="container">
          <div class="list-wrap padding-b-10px">
            <div v-if="!hideButton" class="back">
              <div
                @click="handleBackClick"
                class="d-flex button-container pointer-hover"
              >
                <a-icon class="margin-left-25px" type="arrow-left" />
                <span class="margin-l-1">
                  Back to profile
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="events-content-wrap">
          <div class="head">
            <div class="head-title">
              <div class="name">{{ college.collegeName }}</div>
              <h2 class="form-title">College Team Highlights</h2>
            </div>
            <BaseButton
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="newHighlight"
              v-if="
                !$route.params.id &&
                  (onlyCollegeHeadCoach() || onlyCollegeProfileMaintainer())
              "
              >Add New Highlight</BaseButton
            >
          </div>
          <div class="roster-wrap">
            <a-row :gutter="[24, 32]">
              <a-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-for="(item, index) in collegeTeamHighlights"
                :key="index"
              >
                <CardView :college-team-highlight="item" />
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
  </BaseLoading>
</template>

<script>
import CardView from "./card";
import { mapGetters } from "vuex";
import { Base } from "@/models";

const COLLEGE_TEAM_HIGHLIGHT_STORE = "collegeTeamHighlightStore";
const COLLEGE_STORE_KEY = "collegeStore";

export default {
  components: {
    CardView
  },
  mounted() {
    this.dispatcher();
  },
  computed: {
    ...mapGetters({
      collegeTeamHighlights: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlights`,
      collegeTeamHighlightsLoading: `${COLLEGE_TEAM_HIGHLIGHT_STORE}/collegeTeamHighlightsLoading`,
      college: `${COLLEGE_STORE_KEY}/college`
    }),
    collegeId() {
      return this.$route.params.id
        ? this.$route.params.id
        : localStorage["college-id"];
    },
    profileId() {
      return Base.profileId();
    },
    hideButton() {
      return (
        this.collegeTeamHighlights[0] &&
        this.collegeTeamHighlights[0].collegeId.id ===
          localStorage["college-id"]
      );
    }
  },
  methods: {
    dispatcher() {
      this.$store.dispatch(
        `${COLLEGE_TEAM_HIGHLIGHT_STORE}/getCollegeTeamHighlights`,
        {
          id: this.collegeId,
          limit: 20,
          page: 1
        }
      );
      this.$store.dispatch(`${COLLEGE_STORE_KEY}/getCollege`, {
        id: this.collegeId
      });
    },
    handleBackClick() {
      this.$router.push(
        `/${this.$route.params.profileId}/college_profile/${this.$route.params.id}/summary`
      );
    },
    newHighlight() {
      this.$router.push(
        `/${this.profileId}/college_profile/team_highlights/new`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.events-list-wrap {
  .back-button-wrapper {
    padding: 25px;
    color: #2a328a;
    display: block;
    width: 100%;
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 600;
    background: white;
    height: 5rem;
    .button-container {
      width: 100%;
      place-items: center;
    }
  }
  .events-content-wrap {
    .head {
      .head-title {
        padding-bottom: 30px;
      }
    }
  }
}
</style>
